import { MetricCard } from './MetricCard'

interface IGamesOnlyBots {
  metric: string
}

export const GamesOnlyBots = ({ metric }: IGamesOnlyBots) => {
  return <MetricCard title="Games With Only Bots" metric={metric} icon="smart-toy" />
}
